<!-- Vue component -->
<template>
  <div class="vuemulti">
    <label v-if="label" :style=" { color: labelcolor } ">{{ label }}</label>
    <label class="error-msg" v-if="isInvalid === false">*</label>
    <input
        v-if="!Array.isArray(value)"
        :name="name" :value="value ? value[trackby] : ''"
        :class="{ inputfield: label, 'inputfield-nolabel': !label }"
        :required="required"
    >
    <div id="zoneselectvalue" v-if="Array.isArray(value)" >
      <input :class="{ inputfield: label, 'inputfield-nolabel': !label }"  :name="name + '_required'" v-if="required && value.length < 1" :required="required" value="">  
      <input
          v-for="(i, x) in value"
          v-bind:key="x"
          type="hidden" :name="name +'[]'" :value="i[trackby]"
          :class="{ inputfield: label, 'inputfield-nolabel': !label }"
          :required="required"
      />
    </div>

    <multiselect
        :class="( isInvalid === false ) ? 'error' : ''"
        v-model="value"
        label="label"
        :track-by="trackby"
        :options="valueoptions"
        :taggable="taggable"
        :disabled="disabled"
        :placeholder="placeholder"
        deselectLabel=""
        :allowEmpty="allowEmpty"
        selectLabel=""
        selectedLabel=""
        :close-on-select="closeonselect"
        :multiple="multiple"
        @tag="addTag"
        :loading="loading"
        :max="max"
        @select="onChange"
        @input="inputevent"
        @remove="removeValue"
        :style="cssVars"
        ref="zoneselect"
    >
      <!-- Slote Selezione multipla -->
      <template slot="selection" slot-scope="{ values, search, isOpen }">
          <span
              class="multiselect__single"
              v-if="values && values.length && !isOpen"
          >
            {{ values.length }} {{selection_name }} selezionate
          </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <i v-if="props.option.type !== 'comune' || props.option.selectAll" class="pr-2" :class="{ 'far fa-square': !optionIsSelected(props.option), 'fas fa-check-square': optionIsSelected(props.option)}"></i>
          <span class="option__title">{{ props.option.label }}</span>
        </div>
      </template>

      <template slot="noResult">
          <div>Nessun risultato corrisponde alla ricerca effettuata.</div>
      </template>

      <template slot="maxElements">
        <div>
          Hai raggiunto il limite delle zone selezionabili!
        </div>
      </template>

       <template slot="clear">
            <div :class="{ 'hide': !value || disabled || (Array.isArray(value) && value.length < 1) }" class="multiselect__clear" @mousedown.prevent.stop="clearValue()">
                <i class="far fa-trash-alt trash-icon"></i>
            </div>
        </template>

        <template slot="tag">{{ '' }}</template>

    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: [
    'label',
    'labelcolor',
    'primarycolor',
    'options',
    'name',
    'selectname',
    'isInvalid',
    'currentvalue',
    'trackby',
    'required',
    'disabled',
    'selection_name',
    'allowEmpty'
  ],
  data () {
    return {
      value: null,
      valueoptions: this.options,
      valid: false,
      multiple: true,
      closeonselect: false,
      taggable: false,
      max: 8,
      loading: false,
      placeholder: 'Seleziona...'
    }
  },
  computed: {
    cssVars () {
      return {
        /* variables you want to pass to css */
        '--primaryColor': this.primarycolor ? this.primarycolor : '#ff0000' ,
        '--secondaryColor': this.labelcolor ? this.labelcolor : 'red' ,
      }
    },
  },
  watch: {
    currentvalue (newVal, oldVal) {
       this.value = newVal;
    },
    options: function(newVal, oldVal) {
      if(newVal && newVal.length === 0) {
        this.value = null;
      }
      this.valueoptions = newVal;
    }
  },
  methods: {
    optionIsSelected(option) {
      const finditem = this.loadsh.find(this.value, item => {
        return item.id === option.id;
      })
      return finditem ? true : false;
    },
    onChange (value) {
      if(value.selectAll) {
        this.closeonselect = true;
        // this.max = 1;
          this.valueoptions=this.options;
        this.$refs.zoneselect.$refs.search.blur();
          this.closeonselect = false;

          return;
      }

      if(value.type === 'comune') {
        this.getZoneCustom(value.id);
      } else {
        this.closeonselect = false;
      }
    },
    inputevent(value) {

        // Gestisco la selezione del "Tutte le zone"
        const findAll = this.loadsh.filter(value, (item) => {
          return item.selectAll;
        });

        const findComune = this.loadsh.filter(value, (item) => {
          return !item.selectAll && item.type === 'comune';
        });

        if(findComune.length > 0) {
          this.value = null;
        }

        if(findAll.length > 0) {
            this.value = this.loadsh.filter(value, (item) => {
            return item.selectAll;
          });
        }

        this.$emit('isValid',  { type: this.selectname, isvalid: this.value ? true : false });
        this.$emit('onChange',  this.value);
    },
    removeValue(value) {
      if(value.selectAll) {
        this.closeonselect = false;
        this.max = 8;
      }
    },
    getZoneCustom(comune) {
      this.loading = true;
      window.axios.get(window.base_url + 'zone/comune/' + comune + '/frazioni').then( res => {
        this.valueoptions = res.data.data;
        this.comune_selected = true;
        this.value = null;
        this.loading = false;
        this.placeholder = 'Seleziona una o più zone...'
      });
    },
    getValue(id) {
      return this.options.find((item) => {
        return Number(id) === item[this.trackby];
      });
    },
    clearValue() {
      this.value = null;
      this.valueoptions = this.options;
      this.closeonselect = false;
      this.max = 8;
      this.$emit('clear-value');
    },
    addTag (newTag) {
      const tag = {
        id: newTag,
        label: '€ ' + newTag
      }
      this.value = tag;
    }
  },
}
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">

.multiselect__clear {
    position: absolute;
    right: 35px;
    top: 8px;
    z-index: 9;
    cursor: pointer;
}

.hide {
  opacity: 0;
}

.multiselect__tags {
  border-radius: 0px !important;
}

.vuemulti {
  label {
    color: white;
    font-size: 0.8em;
  }
}

.multiselect__placeholder {
  margin-bottom: 0px !important;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: darkgrey;
  color: black;
}

.multiselect__option--highlight {
  background-color: var(--primaryColor) ;
}

.multiselect__option {
  font-size: 0.8em;

}

.multiselect__option--highlight span {
  color: white !important;
}

.multiselect__single {
  font-size: 1em;
}

.error {
  border: 1px solid red;
}
.multiselect__tag-icon:hover {
  background-color: var(--secondaryColor);
}
.multiselect__tag {
  background-color: var(--primaryColor);
  span {
    color: white;
  }
  i {
    &::after {
      color: white !important;
    }
  }
}

.inputfield {
  position: absolute;
  opacity: 0;
  top: 45px;
  left: 20px;
}

.inputfield-nolabel {
  position: absolute;
  opacity: 0;
  top: 8px;
  left: 20px;
}

.error-msg {
  position: absolute;
  margin-top: -8px;
  font-size: 2em;
}
</style>
